var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcean(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#3331bf",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 135.995,
    y: 152.159,
    width: 16.001,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.001,
    y: 152.159,
    width: 16.001,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.996,
    y: 152.159,
    width: 16.001,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.002,
    y: 152.159,
    width: 16,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.997,
    y: 152.159,
    width: 16.001,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.002,
    y: 152.159,
    width: 16.001,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.997,
    y: 152.159,
    width: 16.001,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.003,
    y: 152.159,
    width: 16,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.1,
    y: 0.162,
    width: 144.657,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.164,
    y: 7.999,
    width: 15.674,
    height: 16.001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.036,424.161c32.784-19.519,54.801-55.315,54.801-96.162v-60.843l-32-16.001V112.161H104.163v138.994l-32,16v60.843 c0,40.848,22.016,76.644,54.801,96.163H0v15.674h512v-15.674H385.036z M119.837,127.835h272.326v64.327H289.849l-33.85-16.924 l-33.849,16.924H119.837V127.835z M392.162,207.836v35.483l-70.966-35.483H392.162z M119.837,207.836h70.966l-70.966,35.483 V207.836z M87.837,276.843L256,192.761l168.164,84.082v22.476L256,215.237L87.837,299.319V276.843z M183.999,424.162 c-53.025,0-96.163-43.138-96.163-96.163v-11.156l168.163-84.082l168.164,84.082v11.156c0,53.025-43.138,96.163-96.163,96.163 H183.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,88.162h-0.001h-24.164V31.999h-15.674v56.163h-40.326v-64H184.163v64h-40.326V31.999h-15.674v56.163H104v15.674h304 V88.162z M312.163,88.162H199.837V39.836h112.326V88.162z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.158,
    y: 7.999,
    width: 15.674,
    height: 16.001
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.001,
    y: 456.165,
    width: 39.999,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.004,
    y: 480.156,
    width: 79.998,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 480.156,
    width: 24,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.999,
    y: 464.159,
    width: 24.001,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.994,
    y: 480.156,
    width: 72,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.003,
    y: 496.164,
    width: 24,
    height: 15.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 464.159,
    width: 95.996,
    height: 15.674
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcean);
export default __webpack_public_path__ + "static/media/ocean.23df7476f36e032d67ca8eec6d0bb3b3.svg";
export { ForwardRef as ReactComponent };